import { STATUS_CONFIG, CATEGORY_CONFIG, KONDISI_CONFIG } from "../lib/constants";

const base =
  "inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[11px] font-bold border whitespace-nowrap";

export const StatusBadge = ({ status }) => {
  const cfg = STATUS_CONFIG[status] || STATUS_CONFIG["Belum Dikerjakan"];
  const spin = cfg.icon.includes("spinner") ? " animate-spin" : "";
  return (
    <span className={`${base} ${cfg.badge}`} data-testid="status-badge">
      <i className={`ph-bold ${cfg.icon}${spin}`} />
      {status}
    </span>
  );
};

export const CategoryBadge = ({ kategori }) => {
  const cfg = CATEGORY_CONFIG[kategori] || CATEGORY_CONFIG.Lainnya;
  return (
    <span className={`${base} ${cfg.badge}`} data-testid="category-badge">
      <i className={`ph-bold ${cfg.icon}`} />
      {kategori}
    </span>
  );
};

export const KondisiBadge = ({ kondisi }) => {
  const cfg = KONDISI_CONFIG[kondisi];
  if (!cfg) return null;
  return (
    <span className={`${base} ${cfg.badge}`} data-testid="kondisi-badge">
      <i className={`ph-bold ${cfg.icon}`} />
      {kondisi}
    </span>
  );
};
